module.exports = __webpack_public_path__ + "static/media/tndr-bnb.91f8b9bd.png";